const hasDom = (typeof window !== 'undefined' && typeof document !== 'undefined')

export default hasDom
